import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const CheckDetailsAndProjectAcceptanceModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=3sLmIJed8Fw&feature=youtu.be&ab_channel=apadua" />
);

export default CheckDetailsAndProjectAcceptanceModal;
